export default __webpack_public_path__ + "static/media/18.919691b5.jpg";